<template>
  <div class="section-main__warp carPatrolBlack-container">
    <!-- 左侧 -->
    <div class="left-content">
      <black-list @queryBackList="queryBackList" ref="blackList"></black-list>
    </div>
    <!-- 右侧 -->
    <div class="right-content">
      <div class="main-content">
        <!-- 过滤条件 -->
        <div class="search-area" style="display: flex; align-items: center">
          <div
            style="display: flex; align-items: center; margin: 5px 0 5px 0; width: 20%"
          >
            <div style="margin-right: 8px">车主：</div>
            <div style="flex: 1; margin-right: 8px">
              <el-input
                placeholder="请输入车主"
                v-model="filterData.ownerName"
              ></el-input>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; margin: 8px 0 8px 0; width: 20%"
          >
            <div style="margin-right: 8px">车牌：</div>
            <div style="flex: 1; margin-right: 8px">
              <el-input
                placeholder="请输入车牌"
                v-model="filterData.plateCode"
              ></el-input>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; margin: 5px 0 5px 0; width: 20%"
          >
            <div style="margin-right: 8px">类型：</div>
            <div style="flex: 1; margin-right: 8px">
              <el-select v-model="filterData.vehicleType" placeholder="请选择">
                <el-option
                  v-for="item in vehicleTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; margin: 5px 0 5px 0; width: 20%"
          >
            <div style="margin-right: 8px">颜色：</div>
            <div style="flex: 1; margin-right: 8px">
              <el-select v-model="filterData.vehicleColor" placeholder="请选择">
                <el-option
                  v-for="item in vehicleColorList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; margin: 5px 0 5px 0; width: 20%"
          >
            <div style="margin-right: 8px">特定车辆：</div>
            <div style="flex: 1; margin-right: 8px">
              <el-select v-model="filterData.isSpecial" placeholder="请选择">
                <el-option
                  v-for="(item, index) in isSpecialList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <div style="flex: 1; padding-right: 8px">
              <el-button type="primary" @click="queryFilter">查询</el-button>
            </div>
            <div style="flex: 1">
              <el-button type="info" @click="resetClick()">重置</el-button>
            </div>
          </div>
        </div>
        <div class="data-content car-patrol-list" v-if="!loading">
          <!-- 全选 -->
          <!-- <el-checkbox :indeterminate="isIndeterminate" v-if="listData && listData.length" v-model="checkAll" @change="handleCheckAllChange" v-auth="'/personMg:deleteList'">{{$t('carPatrolBlack.button.checkAll')}}</el-checkbox> -->
          <!-- 查询结果 -->
          <ioc-table
            :option="optionTabTask"
            :data="taskCenterData"
            :page="pageObj"
            @size-change="sizeChange"
            @current-change="currentChange"
            @selection-change="handleSelectionChange"
            ref="crud"
          >
            <template slot="menuLeft">
              <el-button
                v-auth="'/carPatrolBlack:add'"
                type="primary"
                size="small"
                class="iss-operation-button"
                icon="el-icon-plus"
                @click="createNameList"
              >
                新增
              </el-button>
              <el-button
                @click="batchDelete"
                v-auth="'/carPatrolBlack:delete'"
                type="primary"
                size="small"
                icon="el-icon-delete"
                class="iss-operation-button"
              >
                批量删除
              </el-button>
            </template>
            <template #plateCode="plateCodeData">
              <el-button
                type="text"
                @click="handleView(plateCodeData.row, plateCodeData.$index)"
                >{{ plateCodeData.row.plateCode }}</el-button
              >
              <!-- <span style="cursor: pointer"
                    @click="handleView(scope.row, scope.index)">
                {{scope.row.plateCode}}</span> -->
            </template>
            <!-- 布控列表-按钮操作栏 -->
            <template slot="menu" slot-scope="scope">
              <!-- <el-tooltip
                class="item m5"
                effect="dark"
                content="轨迹查询"
                placement="top-start"
              >
                <span
                  class="iconfont-lunan icon-blue el-icon-location cursor"
                  @click="retBtn(scope.row)"
                ></span
                >&nbsp;&nbsp;&nbsp;&nbsp;
              </el-tooltip> -->
              <el-tooltip
                class="item m5"
                effect="dark"
                :content="$t('carPatrolBlack.button.edit')"
                placement="top-start"
                v-auth="'/carPatrolBlack:update'"
              >
                <span
                  class="icon iconfont icon-blue icon-xiugai cursor"
                  @click="updateClick(scope.row)"
                ></span
                >&nbsp;&nbsp;&nbsp;&nbsp;
              </el-tooltip>
              <el-tooltip
                class="item m5"
                effect="dark"
                :content="$t('carPatrolBlack.button.delete')"
                placement="top-start"
                v-auth="'/carPatrolBlack:delete'"
              >
                <span
                  class="icon iconfont icon-blue icon-shanchu cursor"
                  @click="deleteClick(scope.row)"
                ></span
                >&nbsp;&nbsp;&nbsp;&nbsp;
              </el-tooltip>
            </template>
            <template slot="img" slot-scope="scope">
              <img
                :src="getImgPath(scope.row)"
                class="cursor"
                @click="showViewer(scope.row.fileCode, $event)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 25px; width: 50px"
              />
            </template>
            <template slot="imgView" slot-scope="scope">
              <img
                :src="getImgPath(scope.row)"
                class="cursor"
                @click="showViewer(scope.row.fileCode, $event)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 25px; width: 50px"
              />
            </template>
          </ioc-table>
        </div>
        <div
          class="loading-content"
          v-loading="true"
          style="line-height: 300px"
          v-else
        ></div>
        <!-- <div class="page-content" :style="!listData.length && 'position: absolute;width: 100%;bottom:0px;'">
                    <el-pagination background :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pageObj.pageSize" @current-change="currentChange" @size-change="sizeChange" layout="total, sizes, prev, pager, next, jumper" :total="pageObj.total">
                    </el-pagination>
                </div> -->
      </div>
    </div>

    <!-- 名单表单 -->
    <el-dialog
      :title="
        formState === 1
          ? this.$t('carPatrolBlack.title.addCars')
          : this.$t('carPatrolBlack.title.editCars')
      "
      :visible.sync="listFormShow"
      v-dialogDrag
      @close="cancelListForm"
      :close-on-click-modal="false"
      width="42%"
    >
      <el-form :model="formData" ref="form" :rules="rules" label-width="90px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="车牌" prop="plateCode">
              <el-input
                v-model="formData.plateCode"
                placeholder="请输入车牌"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车主" prop="ownerName">
              <el-input
                v-model="formData.ownerName"
                placeholder="请输入车主"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车辆类型" prop="vehicleType">
              <el-select
                v-model="formData.vehicleType"
                placeholder="请选择车辆类型"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in carType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车身颜色" prop="vehicleColor">
              <el-select
                v-model="formData.vehicleColor"
                placeholder="请选择车身颜色"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in carColor"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车辆品牌" prop="vehicleBrand">
              <el-select
                v-model="formData.vehicleBrand"
                placeholder="请选择车辆品牌"
                filterable
                clearable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in BrandType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特定车辆" prop="isSpecial">
              <el-select
                v-model="formData.isSpecial"
                placeholder="请选择"
                style="width: 100%;"
              >
                <el-option
                  v-for="(item, index) in isSpecialList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$t('personMg.label.startTime')" prop="startTime">
              <el-date-picker style="width:210px" v-model="formData.startTime" type="datetime" :placeholder="$t('personMg.label.startTime')">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('personMg.label.endTime')" prop="endTime">
              <el-date-picker
                style="width:210px"
                v-model="formData.endTime"
                type="datetime"
                :picker-options="pickerOptions2"
                :placeholder="$t('personMg.label.endTime')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-form-item label="车辆图片" prop="fileList">
          <div class="upload-img-content">
            <div class="upload-img-item">
              <el-upload
                action=""
                list-type="picture-card"
                :on-exceed="fileCount"
                :on-change="changeFile"
                :on-remove="removeFile"
                :auto-upload="false"
                :limit="1"
                style="margin-bottom: 10px"
                ref="upload"
                :file-list="fileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input
            style="width: 95%"
            type="textarea"
            v-model="formData.desc"
            placeholder="请输入内容"
            maxlength="255"
            show-word-limit
            :rows="5"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitClick"
          :disabled="isDisabled"
          v-text="$t('carPatrolBlack.button.save')"
        ></el-button>
        <el-button @click="cancelListForm">{{
          $t("carPatrolBlack.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <dialog-map ref="dialogMap"></dialog-map>
  </div>
</template>

<script>
import utils from "@src/common/utils";
// 工具库
import { Dic, Bus, Validate, Dates } from "$utils";
// 服务API
import { API } from "../api";
// 黑名单组
import blackList from "../components/Blacklist";
// 黑名单信息-配置项
import { filterOps } from "../options/filterColumn";
import i18n from "@src/common/lib/i18n";
// 表格的配置
import { tableColumn } from "../options/tableColumn";
import eventBus from "@src/common/utils/eventBus";
import eventConfig from "@src/common/config/eventConfig";
import dialogMap from "@src/components/common/app-dialog/dialog-map";
export default {
  components: {
    blackList,
    dialogMap,
    // dataEmpty
  },
  data() {
    const checkCarNumber = (rule, value, callback) => {
      console.log(this.formData, "222222");
      if (!Validate.isVehicleNumber(value)) {
        callback(new Error(this.$t("carPatrolBlack.message.carformat")));
      } else {
        callback();
      }
    };
    const checkCarOwner = (rule, value, callback) => {
      console.log(value, "233333");
      if (!value.length) {
        callback();
        return false;
      }
      if (!Validate.validateCarOwner(value)) {
        callback(new Error(this.$t("carPatrolBlack.message.ownerformat")));
      } else {
        callback();
      }
    };
    const validateStartTime = (rule, value, callback) => {
      if (!value && this.formData.endTime) {
        callback(new Error("开始/结束时间必须全部有值或全部为空"));
      } else {
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      console.log(
        !value && this.formData.startTime,
        value < this.formData.startTime,
        "222222"
      );
      if (!value && this.formData.startTime) {
        callback(new Error("开始/结束时间必须全部有值或全部为空"));
      } else if (value && value < this.formData.startTime) {
        callback(new Error("结束时间必须大于开始时间"));
      } else {
        callback();
      }
    };
    return {
      viewerInstance: null,
      viewerPhotos: [],
      optionTabTask: {
        view: "查看",
        addBtn: false,
        refreshBtn: false,
        searchBtn: false,
        stripe: true,
        page: true,
        maxHeight: "100%",
        editBtn: false,
        delBtn: false,
        header: false,
        emptyText: this.$t("carPatrol.label.nodata"),
        // 行可勾选
        selection: true,
        column: tableColumn(),
      },
      // 存储布控任务的数据
      taskCenterData: [],
      vehicleColorList: [].concat(Dic.find("SENU039")),
      vehicleTypeList: Dic.find("SENU038"),
      isSpecialList: [
        {
          label: "否",
          value: "0",
        },
        {
          label: "是",
          value: "1",
        },
      ],
      isDisabled: false,
      imgFileList: [], // 保存名单中上传图片数组
      formList: [], // 表单名单组
      imageUrlList: ["", "", "", "", ""], // 上传图片回填
      nowListCode: "", // 当前名单组Code
      pageObj: {
        // 分页数据
        // pageNum: 1,
        currentPage: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        total: 0,
      },
      upDateCode: "", // 修改名单Code
      formState: 1, // 1：新增 2：修改
      listFormShow: false, // 新增修改名单弹窗
      cardStyle: {
        padding: "0px",
        border: "1px solid #134F9A",
        backgroundColor: "#1A2640",
      },
      // 查询结果
      listData: [],
      // 过滤表单配置
      filterOption: {
        emptyBtn: false,
        submitBtn: false,
        column: filterOps(),
      },
      // 过滤表单数据
      filterData: {
        plateCode: "",
        timeData: [],
        ownerName: "",
        vehicleColor: "",
        vehicleType: "",
        isSpecial: "",
      },
      // 查询数据
      queryData: {
        ownerName: "",
        vehicleColor: "",
        isSpecial: "",
        vehicleType: "",
        plateCode: "",
        startDate: "",
        endDate: "",
      },
      carType: Dic.find("SENU038"),
      carColor: Dic.find("SENU039"),
      fileList: [],
      // 新增修改表单数据
      formData: {
        ownerName: "",
        vehicleColor: "",
        vehicleBrand: "",
        isSpecial: "",
        vehicleType: "",
        plateCode: "",
        desc: "",
        repositorCode: "",
        startTime: "",
        endTime: "",
      },
      isIndeterminate: false,
      checkAll: false,
      listCodes: [], // 选中名单数组
      loading: false,
      BrandType: Dic.find("SENU042"),
      rules: {
        plateCode: [
          {
            required: true,
            message: this.$t("carPatrolBlack.message.inputno"),
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
          { validator: checkCarNumber, trigger: "blur" },
        ],
        ownerName: [
          { validator: checkCarOwner, trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        endTime: [{ validator: validateEndTime, trigger: "blur" }],
        startTime: [{ validator: validateStartTime, trigger: "blur" }],
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  watch: {
    "formData.startTime": {
      handler(newValue, oldValue) {
        this.$refs["form"].validateField("endTime", (timeError) => {
          if (!timeError) {
            //当校验通过时，这里面写逻辑代码
          }
        });
      },
    },
    "formData.endTime": {
      handler(newValue, oldValue) {
        this.$refs["form"].validateField("startTime", (timeError) => {
          if (!timeError) {
            //当校验通过时，这里面写逻辑代码
          }
        });
      },
    },
  },
  methods: {
    getImgPath(item) {
      // console.info('item', item)
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    showViewer(imgs, e) {
      // this.viewerPhotos = [e.target.src]; // imgs.map((v) => this.getImgPath(v))
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    // 失败图片
    errorImg(e) {
      console.log(e);
    },
    // 左侧名单点击请求名单数据
    queryBackList(code) {
      if (code) {
        this.nowListCode = code.code;
      } else {
        this.nowListCode = "";
      }
      this.pageObj.currentPage = 1;
      this.listCodes.length = 0;
      this.checkAll = false;
      this.resetClick();
    },
    // 批量删除
    batchDelete() {
      console.log("this.listCodes", this.listCodes);
      if (this.listCodes.length === 0) {
        this.$message.warning(this.$t("carPatrolBlack.message.deleteNameList"));
      } else {
        this.$confirm(
          this.$t("carPatrolBlack.message.choseNameList"),
          this.$t("carPatrolBlack.title.remind"),
          {
            confirmButtonText: this.$t("carPatrolBlack.button.confirm"),
            cancelButtonText: this.$t("carPatrolBlack.button.cancel"),
            type: "warning",
          }
        ).then((res) => {
          this.$fetch(API.bw.deleteBwlist, {
            type: 0,
            vehicleIds: this.listCodes,
          }).then((res) => {
            if (res.success) {
              this.$message.success(this.$t("carPatrolBlack.message.deleteOk"));
              this.listCodes = [];
              this.checkAll = false;
              this.isIndeterminate = false;
              this.getListData();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        });
      }
    },
    // 删除单个名单
    deleteClick(data) {
      this.$confirm(
        this.$t("carPatrolBlack.message.choseNameOne"),
        this.$t("carPatrolBlack.title.remind"),
        {
          confirmButtonText: this.$t("carPatrolBlack.button.confirm"),
          cancelButtonText: this.$t("carPatrolBlack.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.$fetch(API.bw.deleteBwlist, {
          type: 0,
          vehicleIds: [data.vehicleId],
        }).then((res) => {
          if (res.success) {
            this.$message.success(this.$t("carPatrolBlack.message.deleteOk"));
            this.getListData();
          } else {
            this.$message.error(this.$t("carPatrolBlack.message.deleteNo"));
          }
        });
      });
    },
    // 取消新增修改名单
    cancelListForm() {
      this.listFormShow = false;
      this.formData.ownerName = "";
      this.formData.vehicleColor = "";
      this.formData.vehicleBrand = "";
      this.formData.isSpecial = "";
      this.formData.vehicleType = "";
      this.formData.plateCode = "";
      this.formData.desc = "";
      this.formData.repositorCode = "";
      // this.formData.startTime = "";
      // this.formData.endTime = "";
      this.imgFileList.length = 0;
      this.$refs["upload"].clearFiles();
      this.$refs["form"].clearValidate();
    },
    // 修改名单
    updateClick(data) {
      console.log("---datd00000", data);
      this.isDisabled = false;
      this.formState = 2;
      this.upDateCode = data.vehicleId;
      this.listFormShow = true;
      this.formData.ownerName = data.ownerName;
      this.formData.vehicleColor = data.vehicleColor;
      this.formData.vehicleBrand = data.vehicleBrand;
      this.formData.isSpecial = data.isSpecial;
      this.formData.vehicleType = data.vehicleType;
      this.formData.plateCode = data.plateCode;
      this.formData.desc = data.desc;
      this.formData.repositorCode = data.repositorCode;
      // this.formData.startTime = data.startTime;
      // this.formData.endTime = data.endTime;
      this.formData.desc = data.desc;
      this.fileList.length = 0;
      if (data.fileCode) {
        this.fileList.push({
          url: this.getImgPath(data),
          status: "update",
          fileCode: data.fileCode,
        });
      }
    },
    retBtn(row) {
      // let route = {
      //   name: "车辆研判",
      //   path: "/carResearch",
      // }
      // this.$router.push({
      //   name: "carResearch",
      //   params: {
      //     plateCode: row.plateCode,
      //   },
      // });
      // eventBus.emit(eventConfig.MENU_CLICK, route)
      this.$refs.dialogMap.openMap(row, 1);
    },
    // 创建名单
    createNameList() {
      if (!this.nowListCode) {
        this.$message.warning(this.$t("carPatrolBlack.message.noChoseList"));
        return;
      }
      this.isDisabled = false;
      this.formState = 1;
      // 创建黑名单组列表数据回填
      this.formData.repositorCode = this.nowListCode;
      this.listFormShow = true;
    },
    // 全选
    handleCheckAllChange(val) {
      if (val) {
        // 全选
        this.listCodes.length = 0;
        this.isIndeterminate = false;
        this.listData.forEach((item) => {
          this.listCodes.push(item.vehicleId);
        });
      } else {
        this.listCodes = [];
      }
    },
    // 名单选中触发事件
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.listData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.listData.length;
    },
    // 请求名单数据
    getListData() {
      if (!this.nowListCode) {
        this.$message.warning(this.$t("carPatrolBlack.message.noChoseList"));
        return;
      }
      this.listData.length = 0;
      this.loading = true;
      let params = {
        pageNum: this.pageObj.currentPage,
        pageSize: this.pageObj.pageSize,
      };
      this.$fetch(
        API.bw.queryBwPlat,
        Object.assign(params, {
          hwPlatInfoVo: Object.assign(this.queryData, {
            repositorCode: this.nowListCode,
          }),
        })
      ).then((res) => {
        if (res.success) {
          // this.listData = res.returnObj.list
          this.taskCenterData = res.returnObj.list;
          this.pageObj.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
        this.loading = false;
      });
    },
    // 改变页码
    currentChange(e) {
      console.log("改变页码" + e);
      this.pageObj.currentPage = e;
      this.getListData();
      console.log(this.pageObj);
    },
    // 改变Size
    sizeChange(e) {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = e;
      this.getListData();
    },
    // 查询
    queryFilter() {
      this.pageObj.currentPage = 1;
      this.queryData = {
        ownerName: this.filterData.ownerName,
        vehicleColor: this.filterData.vehicleColor,
        isSpecial: this.filterData.isSpecial,
        vehicleType: this.filterData.vehicleType,
        plateCode: this.filterData.plateCode,
        startDate: "",
        endDate: "",
      };
      if (this.filterData.timeData && this.filterData.timeData.length > 0) {
        this.queryData.startDate = this.filterData.timeData[0];
        this.queryData.endDate = this.filterData.timeData[1].split(" ")[0] + " 23:59:59";
        let startDate = Date.parse(this.queryData.startDate.replace(/-/g, "/"));
        let endDate = Date.parse(this.queryData.endDate.replace(/-/g, "/"));
        let interval = endDate - startDate;
        let time = 30 * 24 * 60 * 60 * 1000;
        if (interval > time || interval < 0) {
          this.$message.warning(this.$t("carPatrolBlack.message.searchWarn"));
          return false;
        } else {
          this.getListData();
        }
      } else {
        this.getListData();
      }
    },
    // 重置
    resetClick() {
      this.queryData = {
        ownerName: "",
        vehicleColor: "",
        vehicleType: "",
        isSpecial: "",
        plateCode: "",
        startDate: "",
        endDate: "",
      };
      this.filterData = {
        plateCode: "",
        isSpecial: "",
        timeData: [],
        ownerName: "",
        vehicleColor: "",
        vehicleType: "",
      };
      this.pageObj.currentPage = 1;
      this.getListData();
    },
    // 判断上传文件个数
    fileCount(file, fileList) {
      this.$message.warning(this.$t("carPatrolBlack.message.upWarn"));
    },
    // 添加图片
    changeFile(file, fileList) {
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      this.imgFileList = fileList;
    },
    deleteImg(file, fileList) {
      if (this.formState === 2) {
        if (file.status === "update") {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          this.fileList.splice(index, 1);
        } else {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          fileList.splice(index, 1);
        }
      } else {
        let index = this.fileList.findIndex((item) => {
          return item.url === file.url;
        });
        fileList.splice(index, 1);
      }
      // this.imgFileList = fileList
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = [
        "jpg",
        "png",
        "jpeg",
        "jpe",
        "dib",
        "bmp",
        "JPG",
        "PNG",
        "JPEG",
        "JPE",
        "DIB",
        "BMP",
      ];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);

      if (!isJPG) {
        this.$message.error(this.$t("carPatrolBlack.message.formatWarn"));
        return false;
      }
      const Size = 1024 * 1024 * 4;
      if (file.size > Size) {
        this.$message.error(this.$t("carPatrolBlack.message.sizeWarn"));
        return false;
      }
      return true;
    },
    // 删除图片
    removeFile(file, fileList) {
      console.log(file, fileList);
      if (this.formState === 2) {
        if (file.status === "update") {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          this.fileList.splice(index, 1);
        }
      }
      this.imgFileList = fileList;
    },
    // 新增/修改名单
    submitClick() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.isDisabled = true;
        // 选择图片
        if (this.imgFileList.length) {
          let formData = new FormData();
          this.imgFileList.map((item) => {
            formData.append("files", item.raw);
          });
          let vehicleList = [];

          // 上传图片
          this.$fetch(API.common.batchFileload, formData).then((res) => {
            if (!res.returnObj) {
              this.$message.error(this.$t("carPatrolBlack.message.failUp"));
              return false;
            }
            res.returnObj.map((item) => {
              vehicleList.push(item.fileId);
            });
            // 新增/修改
            let params = {};
            if (this.formData.isSpecial === "") {
              params = {
                ownerName: this.formData.ownerName,
                vehicleColor: this.formData.vehicleColor,
                vehicleBrand: this.formData.vehicleBrand,
                vehicleType: this.formData.vehicleType,
                plateCode: this.formData.plateCode,
                desc: this.formData.desc,
                repositorCode: this.formData.repositorCode,
                vehicleList: vehicleList,
                type: this.$refs.blackList.groupType, // 黑名单 0, 白名单 1
                // startTime: this.formData.startTime
                //   ? Dates.format(this.formData.startTime)
                //   : "",
                // endTime: this.formData.endTime
                //   ? Dates.format(this.formData.endTime)
                //   : "",
              };
            } else {
              params = {
                ownerName: this.formData.ownerName,
                vehicleColor: this.formData.vehicleColor,
                vehicleBrand: this.formData.vehicleBrand,
                isSpecial: this.formData.isSpecial,
                vehicleType: this.formData.vehicleType,
                plateCode: this.formData.plateCode,
                desc: this.formData.desc,
                repositorCode: this.formData.repositorCode,
                vehicleList: vehicleList,
                type: this.$refs.blackList.groupType, // 黑名单 0, 白名单 1
                // startTime: this.formData.startTime
                //   ? Dates.format(this.formData.startTime)
                //   : "",
                // endTime: this.formData.endTime
                //   ? Dates.format(this.formData.endTime)
                //   : "",
              };
            }

            if (this.formState === 2) {
              params = Object.assign(params, { vehicleId: this.upDateCode });
            }

            let url = this.formState === 1 ? API.bw.addBwlist : API.bw.updateBwlist;
            if (this.formState === 2) {
              this.fileList.map((item) => {
                params.vehicleList.push(item.fileCode);
              });
            }
            this.$fetch(url, params).then((res) => {
              if (res.success) {
                this.$message.success(
                  this.formState === 1
                    ? this.$t("carPatrolBlack.title.addOk")
                    : this.$t("carPatrolBlack.title.editOk")
                );
                this.cancelListForm();
                this.getListData();
              } else {
                this.$message.error(
                  this.formState === 1 ? res.msgContent : res.msgContent
                );
              }
              this.isDisabled = false;
            });
          });
        } else {
          // 未选择图片
          // 新增/修改
          let params = {};
          if (this.formData.isSpecial === "") {
            params = {
              ownerName: this.formData.ownerName,
              vehicleColor: this.formData.vehicleColor,
              vehicleBrand: this.formData.vehicleBrand,
              vehicleType: this.formData.vehicleType,
              plateCode: this.formData.plateCode,
              desc: this.formData.desc,
              repositorCode: this.formData.repositorCode,
              vehicleList: [],
              type: 0, // 黑名单 0
              // startTime: this.formData.startTime
              //   ? Dates.format(this.formData.startTime)
              //   : "",
              // endTime: this.formData.endTime
              //   ? Dates.format(this.formData.endTime)
              //   : "",
            };
          } else {
            params = {
              ownerName: this.formData.ownerName,
              vehicleColor: this.formData.vehicleColor,
              vehicleBrand: this.formData.vehicleBrand,
              isSpecial: this.formData.isSpecial,
              vehicleType: this.formData.vehicleType,
              plateCode: this.formData.plateCode,
              desc: this.formData.desc,
              repositorCode: this.formData.repositorCode,
              vehicleList: [],
              type: 0, // 黑名单 0
              // startTime: this.formData.startTime
              //   ? Dates.format(this.formData.startTime)
              //   : "",
              // endTime: this.formData.endTime
              //   ? Dates.format(this.formData.endTime)
              //   : "",
            };
          }

          if (this.formState === 2) {
            params = Object.assign(params, { vehicleId: this.upDateCode });
          }

          let url = this.formState === 1 ? API.bw.addBwlist : API.bw.updateBwlist;
          if (this.formState === 2) {
            this.fileList.map((item) => {
              params.vehicleList.push(item.fileCode);
            });
          }
          this.$fetch(url, params).then((res) => {
            this.isDisabled = false;
            if (res.success) {
              this.$message.success(
                this.formState === 1
                  ? this.$t("carPatrolBlack.title.addOk")
                  : this.$t("carPatrolBlack.title.editOk")
              );
              this.cancelListForm();
              this.getListData();
            } else {
              this.$message.error(this.formState === 1 ? res.msgContent : res.msgContent);
            }
          });
        }
      });
    },
    handleSelectionChange(selected) {
      console.log("selected", selected);
      selected.map((val) => {
        this.listCodes.push(val.vehicleId);
      });
    },
    handleView(row, index) {
      this.$refs.crud.rowView(row, index);
    },
  },
};
</script>

<style lang="scss">
@import "../style/carPatrolBlack.scss";
@import "~@src/common/assets/style/mixin";
.cursor {
  cursor: pointer;
}
.dialog {
  width: 600px;
}
.left-content {
  @include set_theme_color(background-color, page-bg-color);
  // margin: 10px;
}
</style>
<style>
.el-message-box {
  background: #20253f;
}
.el-dialog__title {
  color: #fff;
}
.el-textarea__inner {
  background: #191d31;
}
.carPatrolBlack-container .el-table {
  /* border: 1px solid; */
  width: 100%;
  margin-bottom: 20px;
  /* margin-left: -5%; */
  /* margin-left: calc(-3vw); */
}
.el-textarea .el-input__count {
  background: #191d31;
}
</style>
